













































































import Vue from 'vue';
import {
  Component, Inject, Watch, Prop,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import { Alert, NoticeClass, AuthStore } from '@kasasa/fbase-components/lib';
import { Account } from '@/api/consumeraccountdetails';
import { AccountQualificationDetailsResource } from '@/api/accountqualificationdetails';
import { InControlDetailsResource } from '@/api/incontroldetails';
import { CycleResource, Cycle } from '@/api/cycles';
import AccountQualificationDetailTable from './AccountQualificationDetailTable.vue';
import RewardDetailTable from './RewardDetailTable.vue';
import InControlDetailTable from './InControlDetailTable.vue';
import TunesGrantsTable from './TunesGrantsTable.vue';

@Component({
  computed: mapState(['fiId']),
  components: {
    AccountQualificationDetailTable,
    RewardDetailTable,
    InControlDetailTable,
    TunesGrantsTable,
  },
})
export default class AccountDetailCard extends Vue {
  @Prop({ default: '' }) customerKasasaKey!: string;

  @Prop() account!: Account;

  @Prop() relationship!: string;

  @Prop({ default: false }) expandDetails!: boolean;

  @Prop() cycles!: Map<Number, Cycle>;

  accountCycles: Cycle[] = [];

  fiId!: string;

  loading: boolean = true;

  isExpanded: boolean = false;

  @Inject('AccountQualificationDetailsResource')
  accountQualificationDetailsResource!: AccountQualificationDetailsResource;

  @Inject('InControlDetailsResource')
  inControlDetailsResource!: InControlDetailsResource;

  @Inject('CycleResource')
  cycleResource!: CycleResource;

  mounted() {
    this.isExpanded = this.expandDetails;
    this.loadCyclesForAccount();
  }

  @Watch('expandDetails')
  onExpandDetailsPropChange() {
    this.isExpanded = this.expandDetails;
  }

  @Watch('account')
  async loadCyclesForAccount() {
    if (this.account && this.fiId) {
      this.loading = true;

      let promise: Promise<number[]>;

      if (this.account.kasasaProductType === 'INCONTROL_BURN_DOWN') {
        promise = this.inControlDetailsResource.getCyclesForAccount(
          this.fiId,
          this.account.accountKasasaKey,
        );
      } else {
        promise = this.accountQualificationDetailsResource.getCyclesForAccount(
          this.fiId,
          this.account.accountKasasaKey,
        );
      }

      try {
        const cycleIds: number[] = await Promise.resolve(promise);
        cycleIds.forEach((cycleId: number) => {
          if (this.cycles.has(Number(cycleId))) {
            this.accountCycles.push(this.cycles.get(Number(cycleId)) as Cycle);
          }
        });

        this.accountCycles = this.accountCycles.sort((cycle1: Cycle, cycle2: Cycle): number => new Date(cycle1.qualificationStartDate).getTime() - new Date(cycle2.qualificationStartDate).getTime());
      } catch (error) {
        console.error(error);
        this.showErrorMessage(error);
      } finally {
        this.loading = false;
      }
    }
  }

  loadingMoreQuals() {
    const ref: any = this.$refs.rewardTable;
    ref.loadMore();
  }

  loadingMoreRewards() {
    const ref: any = this.$refs.qualTable;
    ref.loadMore();
  }

  showErrorMessage(error: string) {
    const al = new Alert(error, NoticeClass.ERROR);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }
}
